<template>
	<footer class="innerfooter">
		<div class="container">
			<div class='footer-link' v-if='merchant().ShowFooterLink' v-html='invoice_id_string'></div>
		</div>
	</footer>
</template>

<style scoped lang="scss">
	footer{
		border-top: 1px solid #d4d4d4;
		text-align: center;
		font-size: 16px;
		padding: 30px 0px 0px;
		color: #758191;
		margin-top: 30px;
	}
</style>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Footer",
	components: {},
	computed: {
		invoice_id_string(){
			if(!this.merchant().ShowFooterLink) return '';
			var text = this.merchant().FooterLink.Text;
			var link = "<a href='"+this.merchant().FooterLink.TermsLink+"' target='_blank'>"+this.merchant().FooterLink.LinkText+"</a>";
			link = link.replace("{$id}", this.invoice().id);
			return text.replace("{$link}", link);
		},
		current_date: function(){
			return new Date().getFullYear();
		}
	},
  methods: {
	getText(key){
		return LanguageService.getText(key);
	},
    ...mapGetters(["merchant", "invoice"])
  }
};
</script>
